module.exports = __webpack_public_path__ + "static/media/fast-backward.5715ad6e.svg";